import React, { useEffect } from 'react';

import useSound from 'use-sound';

import { toAbsoluteUrl } from '../_ens/_helpers';

const FanfareButton = (props) => {
  //const [playbackRate, setPlaybackRate] = React.useState(0.75);
  const [count, setCount] = React.useState(0);

  const [play] = useSound(toAbsoluteUrl('/media/sounds/sound1.mp3'), {
    interrupt: true,
    onplay: () => {
      if (props.play === true) {
        setTimeout(()=>{
          setCount(1);
        },10000)
      }
    }
  });

  return <>{props.play === true && count === 0 ? play() : ''}</>;
};

export default FanfareButton;
